import WorkflowCard from "./WorkflowCard";

export function ActionsRow({
  title,
  type,
  actions,
  parentID,
  index,
  openCreateDrawer,
  openEditDrawer,
  CreateButton,
  disableDnd,
  childCard = false,
  errors,
}) {
  return (
    <div className="d-flex flex-column align-items-center w-100">
      <div
        className={`mb-3 px-3 py-1 rounded workflow-evaluation-title ${
          type === "True" ? "eval-true" : "eval-false"
        }`}
      >
        <h4 className="m-0">{title}</h4>
      </div>
      {actions.length > 0
        ? actions.map((a, i) => {
            const dotNumber = (i + 1) / 10;
            a.Index = index + dotNumber;

            return (
              <div className="w-100" key={a.id}>
                <WorkflowCard
                  childCard={childCard}
                  key={i}
                  action={a}
                  length={actions?.length}
                  openCreateDrawer={openCreateDrawer}
                  openEditDrawer={openEditDrawer}
                  disableDnd={disableDnd}
                  errors={errors}
                />
              </div>
            );
          })
        : null}
      <CreateButton actionID={parentID} actionType={type} />
    </div>
  );
}
